// extracted by mini-css-extract-plugin
export default {"bookmark-wrapper":"styles_bookmark-wrapper__minKz"};